import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketingIndexComponent } from './crud-index/crud-index.component';
import { MarketingCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: MarketingIndexComponent,
  },
  {
    path: 'create',
    component: MarketingCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: MarketingCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: MarketingCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MarketingsRoutingModule {}
